import axios from "axios";
import { id } from "date-fns/locale";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import person from "../../../../../../../../src/assets/images/Souvenir/1.png";
import person2 from "../../../../../../../../src/assets/images/Souvenir/2.png";
import person3 from "../../../../../../../../src/assets/images/Souvenir/3.png";
import { serverInfo } from "../../../../../../../App";
// import name from "../../../../../../../src/assets/images/Souvenir/name.png";
import "./CricketJerseryAdmin.css";
import { io } from "socket.io-client";
const CricketJerseyModal = (props) => {
  const { imageCdnUrl, shoketUrl } = useContext(serverInfo);
  let history = useHistory();

  const [topper, setTopper] = useState([]);
  const [lastPaymentDate, setPaymentDate] = useState();
  const [notified, setNotified] = useState(false);
  const socket = useRef();

  useEffect(() => {
    axios
      .get(`/api/admin/topBidder/auction/${props?.auction_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setTopper(res.data.bidding);
        }
      });
    socket.current = io(shoketUrl);
  }, [props?.auction_id, notified]);

  const notify = (id) => {
    let data = {
      bidding_id: id,
      payment_last_date: lastPaymentDate,
    };
    axios.post(`/api/admin/topBidder/auction/notify`, data).then((res) => {
      if (res.data.status === 200) {
        socket.current.emit("refreshNotificationPhone", {
          id: 1,
        });
        setNotified(true);
      }
    });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="bg-dark" style={{ border: "2px solid yellow" }}>
        <div className="d-flex justify-content-end">
          <Button className="continue-button text-black" onClick={props.onHide}>
            X
          </Button>
        </div>
        <h4 className="text-center text-warning my-3">Top Bidders! </h4>
        <div className="container d-flex justify-content-around">
          {topper.map((bidder) => (
            <div className="bidder-1 w-75  ">
              <div className="d-flex justify-content-center align-items-center">
                <img
                  src={imageCdnUrl + bidder.user?.image}
                  alt=""
                  className="img-fluid rounded-circle text-center"
                  style={{ height: "200px", width: "200px" }}
                />
              </div>
              <div className="text-center my-2">
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="person-name-admin w-50 d-flex justify-content-center align-items-center"
                    style={{ height: 60 }}
                  >
                    <p className="text-center d-flex justify-content-center align-items-center">
                      {bidder.user?.first_name} {bidder.user?.last_name}
                    </p>
                  </div>
                </div>

                {/* <Link to={`/superstar-admin/auction/live-biddings-checkout/${bidder.auction_id}`}></Link> */}

                {bidder.notify_status === 1 ? (
                  <button
                    type="button"
                    className="btn btn-warning my-3 btn-sm"
                    disablednotifyun
                  >
                    <i className="fa fa-bell mx-1" aria-hidden="true"></i>{" "}
                    Already notified
                  </button>
                ) : (
                  <div className=" w-100 d-flex justify-content-center align-items-center">
                    <div>
                      <input
                        type="date"
                        placeholder="Enter Payment"
                        onChange={(e) => setPaymentDate(e.target.value)}
                      />
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-warning my-3 btn-sm mx-3"
                        onClick={(e) => notify(bidder.id, bidder.auction_id)}
                      >
                        <i className="fa fa-bell mx-1" aria-hidden="true"></i>{" "}
                        notify
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      {/* <Modal.Footer className="d-flex justify-content-center align-items-center bg-dark">
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default CricketJerseyModal;
